import { Component } from '@angular/core';

@Component({
  selector: 'app-e-way-alert-popup',
  templateUrl: './e-way-alert-popup.component.html',
  styleUrls: ['./e-way-alert-popup.component.css']
})
export class EWayAlertPopupComponent {

}
